<div class="ui-g-12 ui-fluid">
<div class="ui-g-12 ui-lg-12 ui-md-12 background" >
    <div class="ui-g-12">
        <h2 class="title">Formularios</h2>
    </div>
</div>
<div>
  
</div>
  <div class="ui-g-12 ui-md-12 ui-lg-12 ui-fluid p-grid mg" >
    <div class="ui-g-12 ui-md-4 ui-lg-3"  *ngFor="let form of forms; let i = index">
      <div  *ngIf="i % 2 == 0" class="cardBlue ui-g-12 " style="min-height: 295px; display: flex; flex-direction: column; justify-content: space-around;">
        <div class="ui-g-12" style="display: flex;justify-content: center;">
          <img src="{{form.pathIcon}}" style="width: 80px;">
        </div>
        <div class="ui-g-12">
          <span class="ui-g-12 subTitle" style="color: #ffffff !important;">{{form.name}} </span>
        </div>
        <div class="ui-g-12 fondo">
            <i class="pi pi-download" style="color: #073c8f; font-size: 1.5em; margin: 0 2%;"></i>
            <a href="{{form.url}}" target="_blank" class="dowload">Descargar</a>
        </div>
      </div>
      <div  *ngIf="i % 2 != 0" class="cardGray2 ui-g-12 " style="min-height: 295px; display: flex; flex-direction: column; justify-content: space-around;">
          <div class="ui-g-12" style="display: flex;justify-content: center;">
            <img src="{{form.pathIcon}}" style="width: 80px;">
          </div>
          <div class="ui-g-12">
            <span class="ui-g-12 subTitle" >{{form.name}} </span>
          </div>
          <div class="ui-g-12 fondo">
              <i class="pi pi-download" style="color: #073c8f; font-size: 1.5em; margin: 0 2%;"></i>
              <a href="{{form.url}}" target="_blank" class="dowload">Descargar</a>
          </div>
      </div>
    </div>
  </div>
</div>
